import { DoctorReferClinicAddress } from '../components/prescriptionPad/leftPanel/DoctorReferralSearchInput';
import { CREATE_REFERAL } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Response = {
    id?: string;
    success: boolean;
    message?: string;
};

export interface CreateReferalData {
    s_name?: string;
    name?: string;
    id?: number;
    docid?: string;
    group_id?: string;
    patientid?: string;
    note?: string;
    eka_note?: string;
    refer_to_eka?: boolean;
    campaign?: boolean;
    created_at?: string;
    clinic?: DoctorReferClinicAddress;
    doc: DocEntity[];
    visitId?: string;
    referred_doctor_url?: string;
    referred_doctor_oid?: string;
    doc_name?: string;
    doc_phone?: string;
    is_appreciated?: boolean;
    prescriptionId?: string;
    type?: string;
    archived?: boolean;
}

export interface DocEntity {
    id?: string;
    referred_doctor_url?: string;
    name?: Name;
    phone?: Phone;
    clinic?: DoctorReferClinicAddress;
    note?: string;
    s_name?: string;
    s_id?: string;
    type?: 'doctor' | 'speciality';
}

export interface Name {
    l: string;
    f: string;
}
export interface Phone {
    code: string;
    value: string;
}

export default (request: CreateReferalData): Promise<Response> => {
    return fetchWithRefresh(CREATE_REFERAL, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to create referal');
        }
    });
};
